
  import AppTitle from "@/components/app-title.vue";
  export default {
    name: 'IndexPage',
    components: {
      AppTitle
    },
    data() {
      return {
        cateList: [{
            key: "square",
            selected: true,
            name: "不锈钢消防水箱",
            "list": [
              {
                "img": "/images/goods/cate/square_1.jpg"
              }, {
                "img": "/images/goods/cate/square_2.jpg"
              }, {
                "img": "/images/goods/cate/square_3.jpg"
              }, {
                "img": "/images/goods/cate/square_4.jpg"
              }, {
                "img": "/images/goods/cate/square_5.jpg"
              }, {
                "img": "/images/goods/cate/square_6.jpg"
              }, {
                "img": "/images/goods/cate/square_7.jpg"
              }, {
                "img": "/images/goods/cate/square_8.jpg"
              }, {
                "img": "/images/goods/cate/square_9.jpg"
              }, {
                "img": "/images/goods/cate/square_10.jpg"
              }, {
                "img": "/images/goods/cate/square_11.jpg"
              }, {
                "img": "/images/goods/cate/square_12.jpg"
              }, {
                "img": "/images/goods/cate/square_13.jpg"
              }, {
                "img": "/images/goods/cate/square_14.jpg"
              }, {
                "img": "/images/goods/cate/square_15.jpg"
              }, {
                "img": "/images/goods/cate/square_16.jpg"
              }, {
                "img": "/images/goods/cate/square_17.jpg"
              }, {
                "img": "/images/goods/cate/square_18.jpg"
              }, {
                "img": "/images/goods/cate/square_19.jpg"
              }, {
                "img": "/images/goods/cate/square_20.jpg"
              }, {
                "img": "/images/goods/cate/square_21.jpg"
              },
             ],
            "desc": "不锈钢消防水箱由单元矩型模压板，优化组合，任意拼装，利用较少的耗材，通过材料变型的方法达到较佳强度的效果，水箱成型后的线型流畅，立体感好，且能美化市容。"
          },
          {
            key: "warm",
            name: "不锈钢保温水箱",
            list:[],
            desc:""
          },
          {
            key: "life",
            name: "不锈钢生活水箱",
            list:[],
            desc:""
          },
          {
            key: "ic",
            name: "巧克力水箱",
            list:[],
            desc:""
          },
          {
            key: "clean",
            name: "不锈钢承压水箱",
            list:[],
            desc:""
          },
          {
            key: "bdf",
            name: "BDF水箱",
            list:[],
            desc:""
          },
          {
            key: "land",
            name: "地埋式水箱",
            list:[],
            desc:""
          },
          {
            key: "cycle",
            name: "圆柱形水箱",
            list:[],
            desc:""
          },
          {
            key: "space",
            name: "油水分离器",
            list:[],
            desc:""
          },
          {
            key: "room",
            name: "一体化智慧泵房",
            list:[],
          },
          {
            key: "clear",
            name: "水箱消毒器",
            list:[],
            desc:""
          },
          {
            key: "lift",
            name: "污水提升设备",
            list:[],
            desc:""
          },
          {
            key: "provide",
            name: "无负压供水设备",
            list:[],
            desc:""
          },
          {
            key: "fountain",
            name: "喷泉",
            list:[],
            desc:""
          }
        ],
        currentKey:"square",
        productList: [],
        //优秀案例
        advantageList: [],
        productTmp: {},

        partList: [
          "partner_1",
          "partner_2",
          "partner_3",
          "partner_4",
          "partner_5",
          "partner_6",
          "partner_7",
          "partner_8"
        ],
        newsList:[
          {
             "title":"2025年6月不锈钢价格整体呈现弱势运行态势",
             "date":"2025-06-23",
             "content":"截至2025年6月13日当周，不锈钢期货主力合约收于12550元/吨，周K线收阴，持仓量环比上周增持117484手。本周（6月9日 - 6月13日）市场上看，不锈钢期货周内开盘报12665元/吨，最高触及12690元/吨，最低下探至12435元/吨，周度涨跌幅达 - 1.18%。截至2025年6月23日13:44:44，不锈钢期货最新价12480.00元，涨跌值 - 55.00，涨跌幅 - 0.44%。"
          },
          {
             "title":"不锈钢期货价格在5月呈现震荡走势",
             "date":"2025-05-30",
             "content":"5月9日不锈钢主力最新价12550.00元，涨跌值 -10.00元，涨跌幅 -0.08%；5月14日不锈钢主力最新价12565.00元，涨跌值75.00元，涨跌幅0.60%。期货价格的波动也影响了现货市场的价格走势。"
          },
        ],
        desc:"",
      }
    },
    async asyncData(context) {
      let advantageList = [];
      for (var i = 0; i < 8; i++) {
        advantageList.push({
          "img": `index_goods_${i+1}`,
        });
      }

      return {
         advantageList: advantageList,
      }
    },
    mounted() {
      //this.buidDB();
      this.goScroll({
        scroll_begin: document.querySelector(".scroll_begin"),
        scroll_end: document.querySelector(".scroll_end"),
        scroll_div: document.querySelector(".scroll_div"),
      });

      this.maxRequestList(this.cateList,4,this.getGroupProduct);


      this.getNewsList();

    },

    methods: {
      getNewsList(){
         let localData=this.getSessionStorage("news");
         if(localData && localData.length>0){
           let newsList=localData.sort(function(a,b){
             if(a.date){
                return Date.parse(a.date.replace(/-/g,"/")) > Date.parse(b.date.replace(/-/g,"/")) ?-1:1;
             }
           });
           this.newsList=newsList.slice(0,2);
         }else{
            this.$request.newsMgr.getList().then((result)=>{
               if(result && result.list){
                  let newsList=result.list.sort(function(a,b){
                    if(a.date){
                       return Date.parse(a.date.replace(/-/g,"/")) > Date.parse(b.date.replace(/-/g,"/")) ?-1:1;
                    }
                  });
                  this.newsList=newsList.slice(0,2);
                  this.setSessionStorage("news",newsList);
               }
            });
         }
      },

      //并发请求
      /**
       * 限制并发请求数量的函数
       * @param {Array} array - 要处理的数据数组
       * @param {number} limit - 最大并发请求数
       * @param {Function} request - 处理单个数据项的请求函数，接收(item, callback)参数
       */
      maxRequestList(array, limit, request) {
          // 参数校验
          if (!Array.isArray(array)) {
              console.error('maxRequestList: 第一个参数必须是数组');
              return;
          }

          if (array.length === 0) {
              return; // 空数组直接返回
          }

          // 调整limit不超过数组长度
          limit = Math.min(limit, array.length);

          // 创建请求队列
          const requestQueue = [...array];

          // 当前活跃的请求数
          let activeRequests = 0;

          // 处理下一个请求的函数
          const processNextRequest = () => {
              // 如果队列为空且没有活跃请求，说明全部处理完成
              if (requestQueue.length === 0 && activeRequests === 0) {
                  return;
              }

              // 当有空闲槽位且队列不为空时，继续处理请求
              while (activeRequests < limit && requestQueue.length > 0) {
                  const item = requestQueue.shift();

                  activeRequests++;

                  // 执行请求并在完成后处理下一个
                  request(item, () => {

                      activeRequests--;
                      // 当一个请求完成后，尝试处理下一个
                      processNextRequest();
                  });
              }
          };

          // 开始处理请求
          processNextRequest();
      },

      onCate(item,index) {
        for (let cate of this.cateList) {
          this.$set(cate, "selected", false);
        }
        this.$set(item, "selected", true);

        if(this.cateList[index].list.length==0){
          this.getProduct(item.key);
        }
      },

      getGroupProduct(item, callback) {
        this.getProduct(item.key)
          .then(() => {
            callback(); // 每个请求成功完成后立即调用回调
          })
          .catch(error => {
            console.error('请求出错:', error);
            callback(); // 即使出错也确保调用回调，避免阻塞
          });
     },

     getProduct(key) {
        const localData=this.getSessionStorage(key) || {};
        if(localData.list && localData.list.length>0){
           let currentCate=this.cateList.find(f=>f.key==localData.key);
           currentCate.list=localData.list || [];
           currentCate.desc=this.toHtml(localData.desc || "");
           return Promise.resolve();
        }

        return this.$request.productMgr.getCateType(key).then((result) => {
          if(result){
            let current=this.cateList.find(f=>f.key==result.key);
            current.list=result.list || [];
            current.desc=this.toHtml(result.desc || "");

            this.setSessionStorage(result.key,result);
          }
        });
      },

      getSessionStorage(key){
        return window.sessionStorage.getItem(key)? JSON.parse(window.sessionStorage.getItem(key)) :null;
      },
      setSessionStorage(key,data){
         window.sessionStorage.setItem(key,JSON.stringify(data));
      },

      toHtml(str) {
          var arrEntities = {
            'lt': '<',
            'gt': '>',
            'nbsp': ' ',
            'amp': '&',
            'quot': '"'
          };
          return str.replace(/&(lt|gt|nbsp|amp|quot);/ig,
            function(all, t) {
              return arrEntities[t];
            });
      },
      goScroll(obj) {
          var self = this;
          var speed = 10;
          var scroll_begin = obj['scroll_begin'];
          var scroll_end = obj['scroll_end'];
          var scroll_div = obj['scroll_div'];

          if (!self.MyMar) {
            self.MyMar = setInterval(Marquee, speed);
          }

          function Marquee() {
            if (scroll_end.offsetWidth - scroll_div.scrollLeft <= 0) {
              scroll_div.scrollLeft -= scroll_begin.offsetWidth;
            } else {
              scroll_div.scrollLeft++;
            }
          }

          scroll_div.onmouseover = function() {
            clearInterval(self.MyMar);
          }
          scroll_div.onmouseout = function() {
            self.MyMar = setInterval(Marquee, speed);
          }
        },
      // 初始化瀑布流
      initWaterfall() {
        const container = this.$el.querySelector('.waterfall-container');
        if (!container || this.productList.length === 0) return;

        // 计算列宽
        this.columnWidth = (container.clientWidth - 40) / this.columns; // 40是左右margin的总和

        // 重置列高度数组
        this.columnHeights = new Array(this.columns).fill(0);

        // 处理所有已加载的项
        this.renderWaterfall();

        this.isWaterfallInit = true;
      },

      canvas() {
        let width = 500;
        let height = 200;
        let canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        let ctx = canvas.getContext("2d");

        var catchImgMap = window.localStorage.getItem("imgMap") ? JSON.parse(window.localStorage.getItem(
          "imgMap")) : {};
        for (let item of this.list) {
          var cacheImg = catchImgMap[item.img];
          if (cacheImg) {
            item.src = cacheImg;
          } else {
            let img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = item.img;
            img.onload = (e) => {
              ctx.clearRect(0, 0, width, height);
              ctx.drawImage(img, 0, 0, width, height);
              catchImgMap[item.img] = canvas.toDataURL("image/jpg", 1)
              item.src = catchImgMap[item.img];
              window.localStorage.setItem("imgMap", JSON.stringify(catchImgMap));
            }
          }
        }
      },
      buidDB() {
        var self = this;
        //1.打开/创建一个 IndexedDB 数据库（当该数据库不存在时，open 方法会直接创建一个名为 xiaoceDB 新数据库）。
        // 后面的回调中，我们可以通过event.target.result拿到数据库实例
        let db = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB;
        // 参数1位数据库名，参数2为版本号
        const request = window.indexedDB.open("hh", 1)
        // 使用IndexedDB失败时的监听函数
        request.onerror = function(event) {
          console.log('无法使用IndexedDB')
        }


        //2.创建一个 object store（object store 对标到数据库中的“表”单位）。
        // onupgradeneeded事件会在初始化数据库/版本发生更新时被调用，我们在它的监听函数中创建object store
        request.onupgradeneeded = function(event) {
          //  db = event.target.result
          // let objectStore
          // // 如果同名表未被创建过，则新建test表
          // if (!db.objectStoreNames.contains('test')) {
          //   objectStore = db.createObjectStore('test', { keyPath: 'id' })
          // }
          db = event.target.result;
          var objectStore = db.createObjectStore('person', {
            keyPath: 'id'
          });
          objectStore.createIndex('name', 'name', {
            unique: false
          });
          objectStore.createIndex('email', 'email', {
            unique: true
          });

        }




        // 成功
        request.onsuccess = function(event) {
          // 此处就可以获取到db实例
          db = event.target.result
          console.log("你打开了IndexedDB")


          // 新增数据

          self.add(db);


          function read() {
            //读取数据
            var transaction = db.transaction(['person']);
            var objectStore = transaction.objectStore('person');
            var request = objectStore.get(2);
            request.onerror = function(event) {
              console.log('事务失败');
            };
            request.onsuccess = function(event) {
              if (request.result) {
                console.log("读取数据", request)
                // console.log('Name: ' + request.result.name);
                // console.log('Age: ' + request.result.age);
                // console.log('Email: ' + request.result.email);
              } else {
                console.log('未获得数据记录');
              }
            };
          }
          read();


          //遍历数据
          function readAll() {
            var objectStore = db.transaction('person').objectStore('person');
            objectStore.openCursor().onsuccess = function(event) {
              var cursor = event.target.result;
              if (cursor) {
                console.log('Id: ' + cursor.key);
                console.log('Name: ' + cursor.value.name);
                console.log('Age: ' + cursor.value.age);
                console.log('Email: ' + cursor.value.email);
                cursor.continue();
              } else {
                console.log('没有更多数据了！');
              }
            };
          }
          readAll();


          //更新数据
          function update() {
            var request = db.transaction(['person'], 'readwrite')
              .objectStore('person')
              .put({
                id: 1,
                name: '李四',
                age: 35,
                email: 'lisi@example.com'
              });
            request.onsuccess = function(event) {
              console.log('数据更新成功');
            };
            request.onerror = function(event) {
              console.log('数据更新失败');
            }
          }
          update();



          //3.构建一个事务来执行一些数据库操作，像增加或提取数据等。
          // 创建事务，指定表格名称和读写权限
          /* const transaction = db.transaction(["test"],"readwrite")
          // 拿到Object Store对象
          const objectStore = transaction.objectStore("test")
          // 向表格写入数据
          objectStore.add({id: 1, name: 'xiuyan'}) */

          //4.通过监听正确类型的事件以等待操作完成。
          // 操作成功时的监听函数
          // transaction.oncomplete = function(event) {
          //   console.log("操作成功")
          // }
          // // 操作失败时的监听函数
          // transaction.onerror = function(event) {
          //   console.log("这里有一个Error")
          // }



        }
      },
      add(db) {
        var request = db.transaction(['person'], 'readwrite')
          .objectStore('person')
          .put({
            id: 1,
            name: '张三',
            age: 24,
            email: 'zhangsan@example.com'
          })
        //.add
        request.onsuccess = function(event) {
          console.log('数据写入成功');
        };
        request.onerror = function(event) {
          console.log('数据写入失败');
        }
      }
    },
  }
